import React from "react";
import { Row, Col, Icon, Card, Button } from "antd";
import { StatusBadgeComponent } from "../StatusBadge/StatusBadgeComponent";
import { imageUrlPath } from "../../../components/Settings";
import placeholder from "../../../media/placeholder.png";

const INTERNAL_PROOF_STATUS_CODE = 517;
const CUSTOMER_PROOF_STATUS_CODE = 518;

export const DetailsComponent = props => {
  const {
    admaterial,
    preflightReport,
    language,
    tableData,
    isClient
  } = props;
  const imageAd = admaterial.format === "jpg" || admaterial.format === "png";
  let previewUrl = admaterial.bigpreview
    ? imageUrlPath + admaterial.bigpreview.url
    : admaterial.preview
      ? imageUrlPath + admaterial.preview.url
      : placeholder;
  if (imageAd) {
    previewUrl = imageUrlPath + admaterial.original[0].url;
  }
  return (
    <div className="mobile--card">
      <Card
        title={admaterial.externalid}
        size="small"
        actions={[
          <React.Fragment>
            {((admaterial.status.code === CUSTOMER_PROOF_STATUS_CODE && isClient) || (admaterial.status.code === INTERNAL_PROOF_STATUS_CODE && !isClient)) && (
              <Button size="small" type="primary" onClick={props.onEdit}>
                <span style={{ textTransform: "uppercase" }}>
                  {language.data.review}
                </span>
              </Button>
            )}
          </React.Fragment>
        ]}
      >
        <Row gutter={12}>
          <Col span={24}>
            <div
              id="detailsPreviewImage"
              style={{ backgroundImage: "url(" + previewUrl + ")" }}
            />
            <img
              style={{ display: "none", width: "100%" }}
              src={previewUrl}
              alt="thumbnail"
            />
          </Col>
          <Col span={12} style={{ padding: "5px" }}>
            {preflightReport &&
              (!preflightReport.error && !preflightReport.fatalError) &&
              preflightReport.haserrors && (
                <span id="detailsPreflightResult" style={{ color: "tomato" }}>
                  <Icon type="close-circle" /> Preflight Error
                </span>
              )}
            {preflightReport &&
              (!preflightReport.error && !preflightReport.fatalError) &&
              !preflightReport.haserrors && (
                <span id="detailsPreflightResult" style={{ color: "tomato" }}>
                  <Icon type="close-circle" /> Preflight Error
                </span>
              )}
            {preflightReport &&
              (preflightReport.error || preflightReport.fatalError) && (
                <span id="detailsPreflightResult" style={{ color: "#e67e22" }}>
                  <Icon type="warning" /> No data to display
                </span>
              )}
          </Col>
          <Col span={12} style={{ padding: "5px" }}>
            <StatusBadgeComponent status={admaterial.status} />
          </Col>
          <Col span={24}>
            <ul className="mobile--list">
              {tableData &&
                tableData.map((item, index) => {
                  return (
                    <li key={index}>
                      <span className="mobile--list--property">
                        {item.prop}
                        {": "}
                      </span>
                      {item.val}
                    </li>
                  );
                })}
            </ul>
          </Col>
        </Row>
        {props.children}
      </Card>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Mobile/Details/DetailsComponent.js